import { ICON_SET_FONTAWESOME } from 'constants-activate';
import { SIDE_BAR_LINKS_ORDER } from 'lane-shared/helpers/constants/sidebarLinksOrder';
import { PERMISSION_KEYS } from 'constants-permissions';
import i18n from 'localization';
import type { UserType } from 'application-types';
import { useInspectionsTemplateLibraryEnabled } from 'react-hooks';

import { hasPermissionOrSuperUser } from 'lane-shared/helpers/hasPermission';
import { SidebarLinkType, SidebarCategoryType } from 'hooks/useChannelSidebarLinks';

import { useInspectionsAdminDashboardFlag } from '../hooks/useInspectionsAdminDashboardFlag';

export enum INSPECTIONS_LINKS_ORDER {
  DASHBOARD,
  TEMPLATE_LIBRARY,
}

const INSPECTIONS_PATH = 'inspections';
export const DASHBOARD_PATH = `${INSPECTIONS_PATH}/dashboard`;
export const TEMPLATE_LIBRARY_PATH = `${INSPECTIONS_PATH}/template-library`;

const emptyLinks: SidebarLinkType[] = [];

export const useInspectionsNavigation = (
  url: string,
  channelId: string,
  user: UserType
) => {
  const inspectionsAdminDashboardFlag = useInspectionsAdminDashboardFlag();
  const inspectionsTemplateLibraryFlag = useInspectionsTemplateLibraryEnabled();

  const navigation: SidebarCategoryType = {
    icon: 'clipboard-check',
    iconSet: ICON_SET_FONTAWESOME,
    name: i18n.t('web.admin.inspections.title'),
    isCategory: true,
    order: SIDE_BAR_LINKS_ORDER.INSPECTIONS,
    links: emptyLinks,
  };

  if (!channelId || !user) {
    return navigation;
  }

  const links: SidebarLinkType[] = [];

  if (
    inspectionsAdminDashboardFlag &&
    hasPermissionOrSuperUser(
      user,
      [PERMISSION_KEYS.PERMISSION_INSPECTIONS_COMPLETE],
      channelId
    )
  ) {
    links.push({
      exact: true,
      route: `${url}/${DASHBOARD_PATH}`,
      name: i18n.t('web.admin.inspections.dashboard.title'),
      headerMessage: i18n.t('web.admin.inspections.dashboard.headerMessage'),
      order: INSPECTIONS_LINKS_ORDER.DASHBOARD,
    });
  }

  if (
    inspectionsTemplateLibraryFlag &&
    hasPermissionOrSuperUser(
      user,
      [PERMISSION_KEYS.PERMISSION_INSPECTIONS_TEMPLATES_MANAGE],
      channelId
    )
  ) {
    links.push({
      exact: true,
      route: `${url}/${TEMPLATE_LIBRARY_PATH}`,
      name: i18n.t('web.admin.inspections.templateLibrary.title'),
      headerMessage: i18n.t('web.admin.inspections.templateLibrary.headerMessage'),
      order: INSPECTIONS_LINKS_ORDER.TEMPLATE_LIBRARY,
    });
  }

  return {
    ...navigation,
    links,
  };
};
